/**
 * Formats an account number like "SB1234567890" into "SB 1234 567 890"
 * Assumes first 2 characters are prefix (e.g., "SB")
 * Groups the rest as 4-3-3 pattern
 */
export function FormatWalletNumber(input: string): string {
  if (input.length <= 2) return input;
  input=input.replaceAll(" ",'').trim()

  const prefix = input.slice(0, 2);
  const number = input.slice(2);

  const groups = [4, 3, 3];
  let formatted = prefix;
  let start = 0;

  for (const length of groups) {
    const end = start + length;
    if (start >= number.length) break;
    formatted += ' ' + number.slice(start, end);
    start = end;
  }

  return formatted;
}
